import { render, staticRenderFns } from "./cadperfilfluxocaixa.vue?vue&type=template&id=2cf9127e&"
import script from "./cadperfilfluxocaixa.vue?vue&type=script&lang=js&"
export * from "./cadperfilfluxocaixa.vue?vue&type=script&lang=js&"
import style0 from "./cadperfilfluxocaixa.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports